import React from 'react';
import TickIcon from '../svg/tick';
export default function FilterSeatsByPrice(props) {

    return (
        <button type="button" 
                className='btn--filter booking-pathway__filters--button' 
                onClick={() => props.setSelectedBands(props.selectedBands == props.price.amount ? null : [props.price.amount])}
                aria-selected={props.selectedBands == props.price.amount}>
            {props.price.color ? <span className='booking-pathway__filters--button-icon' style={{"--circle--color": props.price.color }}><TickIcon/></span> : ""}
            £{parseFloat(props.price.amount).toFixed(2)}
        </button>
    );
}